var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "baseline-public-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__OL-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Single-Location",
    transform: "translate(-32.000000, -862.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Group-9",
    transform: "translate(30.000000, 613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Group-4",
    transform: "translate(0.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__baseline-public-24px",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Shape",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M11,19.93 C7.05,19.44 4,16.08 4,12 C4,11.38 4.08,10.79 4.21,10.21 L9,15 L9,16 C9,17.1 9.9,18 11,18 L11,19.93 Z M17.9,17.39 C17.64,16.58 16.9,16 16,16 L15,16 L15,13 C15,12.45 14.55,12 14,12 L8,12 L8,10 L10,10 C10.55,10 11,9.55 11,9 L11,7 L13,7 C14.1,7 15,6.1 15,5 L15,4.59 C17.93,5.78 20,8.65 20,12 C20,14.08 19.2,15.97 17.9,17.39 Z",
    id: "languages-black_svg__languages-black_svg__languages-black_svg__languages-black_svg__Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.6040cf0246ba590598c9fb56571b786a.svg";
export { ForwardRef as ReactComponent };